export const STATUS_META = {
  posted: { label: 'Posted', card: 'bg-green-50 text-green-800 border-green-200', badge: 'bg-green-100 text-green-800' },
  proposed: { label: 'Proposed', card: 'bg-blue-50 text-blue-800 border-blue-200', badge: 'bg-blue-100 text-blue-800' },
  already_paid: { label: 'Already Paid', card: 'bg-emerald-50 text-emerald-800 border-emerald-200', badge: 'bg-emerald-100 text-emerald-800' },
  unmatched: { label: 'Unmatched', card: 'bg-amber-50 text-amber-800 border-amber-200', badge: 'bg-amber-100 text-amber-800' },
  needs_review: { label: 'Needs Review', card: 'bg-violet-50 text-violet-800 border-violet-200', badge: 'bg-violet-100 text-violet-800' },
  ignored: { label: 'Ignored', card: 'bg-slate-50 text-slate-700 border-slate-200', badge: 'bg-slate-100 text-slate-600' },
  ambiguous: { label: 'Ambiguous', card: 'bg-orange-50 text-orange-800 border-orange-200', badge: 'bg-orange-100 text-orange-800' },
  returned: { label: 'Returned', card: 'bg-red-50 text-red-800 border-red-200', badge: 'bg-red-100 text-red-800' },
};

export const CARD_ORDER = ['posted', 'proposed', 'already_paid', 'unmatched', 'needs_review', 'ignored', 'ambiguous', 'returned'];

export const statusLabel = (s) => STATUS_META[s]?.label || (s || '').replace(/_/g, ' ');
export const statusBadge = (s) => STATUS_META[s]?.badge || 'bg-red-50 text-red-700';

export const fmtMoney = (n) =>
  `$${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDateET = (iso) =>
  iso ? new Date(iso).toLocaleDateString('en-US', { timeZone: 'America/New_York' }) : '-';

const todayET = () => new Date().toLocaleDateString('en-CA', { timeZone: 'America/New_York' });

const daysAgoET = (days) => {
  const d = new Date(`${todayET()}T12:00:00`);
  d.setDate(d.getDate() - days);
  return d.toLocaleDateString('en-CA');
};

export const DATE_PRESETS = [
  { key: '30', label: '30 days', range: () => ({ from: daysAgoET(30), to: todayET() }) },
  { key: '60', label: '60 days', range: () => ({ from: daysAgoET(60), to: todayET() }) },
  { key: '90', label: '90 days', range: () => ({ from: daysAgoET(90), to: todayET() }) },
  { key: 'year', label: 'This year', range: () => ({ from: `${todayET().slice(0, 4)}-01-01`, to: todayET() }) },
  { key: 'all', label: 'All', range: () => ({ from: '', to: '' }) },
];

export const qboBillUrl = (id) => `https://qbo.intuit.com/app/bill?txnId=${id}`;
export const qboBillPaymentUrl = (id) => `https://qbo.intuit.com/app/billpayment?txnId=${id}`;

export const IGNORABLE = ['unmatched', 'ambiguous', 'error', 'needs_review', 'over_balance', 'partial_not_allowed', 'unmapped_account'];
export const APPROVABLE = ['proposed', 'needs_review'];
